export const perfNow = (): number =>
  typeof window !== 'undefined' && window.performance && window.performance.now ? window.performance.now() : Date.now();
